<template>
  <v-app id="inspire" style="background-color:#f3f3f3!important">
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="black"
      dark
    >
      <v-toolbar-title
        style="width: 350px" class="mt-2"
      >
        <a href="/" class="white--text" style="text-decoration: none ">
          <img
            width="230"
            height="50"
            :src="require('../assets/img/logo.jpg')"
          />
        </a>
      </v-toolbar-title>
       <h3 class="ml-10 text-uppercase"> {{ this.$router.currentRoute.name }} </h3>
       <v-spacer />
      <v-btn v-on="on" href="https://www.youtube.com/channel/UC9Cq2MvIXeOGIxgVVffaHNQ" icon>
          <v-icon>mdi-youtube</v-icon>
      </v-btn>
      <v-btn v-on="on" href="https://web.facebook.com/Cechelectroacustica/" icon>
          <v-icon>mdi-facebook</v-icon>
      </v-btn>
      <v-btn v-on="on" href="https://www.instagram.com/comunidad_electroacustica/?hl=es-la" icon>
          <v-icon>mdi-instagram</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <v-bottom-navigation

        color="black"
        horizontal
        class="justify-start"
      >
        <v-btn href="/comunidad">
          <span class=" text-uppercase">La Comunidad</span>
        </v-btn>
        <v-btn href="/miembros">
          <span class=" text-uppercase">Miembros</span>
        </v-btn>
        <v-btn href="/podcast">
          <span class=" text-uppercase">Podcast</span>
        </v-btn>
        <v-btn href="mailto:cech.cl@gmail.com">
            <span class=" text-uppercase">Contacto</span>
        </v-btn>
        <v-btn href="https://festival.comunidadelectroacustica.cl/" class="purple text--white">
          <span class="white--text text-uppercase">AI MAAKO</span>
        </v-btn>

      </v-bottom-navigation>
    </v-content>
   <v-container style="justify-content:center;">
      <router-view style="max-width:900px; margin-left: auto!important;
    margin-right: auto!important;"/>
   </v-container>
    <v-footer
      :padless="true"
    >
      <v-card
        flat
        tile
        width="100%"
        class="black white--text text-center"
      >
        <v-card-text class="white--text pt-0">
          <v-row>
            <v-col cols="4">
              <h3
                style="font-weight: 300; text-align:left;
                        line-height: 1.5;
                        text-transform: uppercase;
                        margin: 0 0 1.5rem 0;
                        font-size: 1.25rem;
                        "
              >COMUNIDAD ELECTROACUSTICA DE CHILE</h3>
              <div style="text-align:left; margin: 0 0 0 1.5rem;">
                <img src="../assets/img/miembros/logo.png" />
                <div><small>PROYECTO FINANCIADO POR EL FONDO PARA EL FOMENTO DE LA MÚSICA NACIONAL, CONVOCATORIA 2020</small></div>
              </div>
            </v-col>
            <v-col style="padding-bottom:14px; margin-bottom:40px;">
						<h4 class="text-uppercase" style=" font-weight: 400; text-align-rigth; justify-content: left;     height: 40px; ">Enlaces</h4>
              <v-row justify="center">
                <v-btn style="width:160px; border-radius:2px; justify-content: left;" class="mb-1 black white--text"  href="/comunidad">
                   <span style="margin-left:20px; font-weight: 200;">La Comunidad</span>
                </v-btn>
              </v-row>
              <v-row justify="center">
                <v-btn style="width:160px; border-radius:2px; justify-content: left;" class="mb-1 black white--text" href="/miembros">
                   <span style="margin-left:20px; font-weight: 200;">Miembros</span>
                </v-btn>
              </v-row>
              <v-row justify="center">
                <v-btn style="width:160px; border-radius:2px; justify-content: left;" class="mb-1 black white--text" href="mailto:cech.cl@gmail.com">
                   <span style="margin-left:20px; font-weight: 200;">CONTACTO</span>
                </v-btn>
              </v-row>
              <v-row justify="center">
                <v-btn style="width:160px; border-radius:2px; justify-content: left;" class="mb-1 black white--text" href="https://festival.comunidadelectroacustica.cl/">
                  <span style="margin-left:20px; font-weight: 200;">AI MAAKO</span>
                </v-btn>
              </v-row>
            </v-col>
            <v-col cols="3">
              <h4 class="text-uppercase" style=" font-weight: 400; text-align-rigth;     height: 40px;">Redes</h4>
              <v-row justify="center">
                <v-btn
                  class="black white--text"
                  href="https://www.youtube.com/channel/UC9Cq2MvIXeOGIxgVVffaHNQ"
                  style="width:150px; border-radius:1; font-weigth:300" >
                  <v-icon class="red--text">
                        mdi-youtube
                  </v-icon>
                  <span style="margin-left:40px; font-weight: 400;">Youtube</span>
                </v-btn>
              </v-row>
              <v-row justify="center">
                <v-btn
                  class="black white--text"
                  href="https://web.facebook.com/Cechelectroacustica/"
                  style="width:150px; border-radius:1">
                  <v-icon class="blue--text">
                        mdi-facebook
                  </v-icon>
                  <span style="margin-left:30px; font-weight: 400;">Facebook</span>
                </v-btn>
              </v-row>
              <v-row justify="center">
                <v-btn
                  class="black white--text"
                  href="https://www.instagram.com/comunidad_electroacustica/?hl=es-la" style="width:150px; border-radius:1">
                  <v-icon class="purple--text">
                        mdi-instagram
                  </v-icon>
                  <span style="margin-left:20px; font-weight: 400;">Instagram</span>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} — © <span>COMUNIDAD ELECTROACUSTICA DE CHILE.</span>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>
<script>
    export default {
        data () {
            return {
                items: [
                    { title: 'T-Shirts' },
                    { title: 'Jackets' },
                    { title: 'Shirts' },
                    { title: 'Jeans' },
                    { title: 'Shoes' },
                ],
                activeBtn: 1,

            }
        },
    }
</script>
<style scoped>
    ul{
      list-style: disc;
    margin: 0 0 2rem 0;
    padding-left: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue